import { useGetProspectQuery } from "types/generated/operations";
import { UserRenderer } from "./user-renderer";

export function ExamplePage() {
  const { data, error, loading } = useGetProspectQuery({
    variables: { uuid: "79e759e0-d6c4-49e7-b57a-82cbea1b7386" },
  });
  if (loading) {
    return <div>Page is loading....</div>;
  }
  if (error) {
    return <div>{`There is an error ${error}`}</div>;
  }
  if (!data) {
    return <div>There was no data</div>;
  }
  return (
    <div>
      <p>This is the logged in user</p>
      <UserRenderer prospect={data.prospect} />
    </div>
  );
}
